import $ from 'jquery';

$(document).ready(function() {
    let item = '',
        text = '',
        id = '',
        count = 0;
    $(document).on('click', '.js-calendar-filter-item', function(e) { 
    	if (!((e.target).closest('.b-calendar-filter__inner-list'))) {
	    	$('.b-calendar-filter__inner-list').slideUp();
            if ($(this).hasClass('active')) {
                $('.js-calendar-filter-item').removeClass('active');
            } else {
                $('.js-calendar-filter-item').removeClass('active');
                $(this).addClass('active');
            }
	    	if ($(this).hasClass('active')) {
	    		$(this).find('.b-calendar-filter__inner-list').slideDown();
	    	} else {
	    		$(this).find('.b-calendar-filter__inner-list').slideUp();
	    	}
    	}
    });
    $(document).on('click', '.js-calendar-filter-inner-item', function() {
        $(this).toggleClass('active');
        if ($(this).parents('.js-calendar-filter-item').find('.js-calendar-filter-inner-item.active').length > 0) {
            $(this).parents('.js-calendar-filter-item').addClass('chosen');
        } else {
            $(this).parents('.js-calendar-filter-item').removeClass('chosen');
        }
        text = $(this).text();
        id = $(this).attr('data-id');
        if ($(this).hasClass('active')) {
            item = '<li class="b-calendar-filter__chosen-item js-calendar-filter-chosen-item" data-chosen-id="' + id + '">' + text + '<svg data-svg="close"><use xlink:href="/images/sprites.svg#close"></use></svg></li>';
            $('.js-calendar-filter-chosen-list').append(item);
            count++;
        } else {
            $('.js-calendar-filter-chosen-item').each(function() {
                if ($(this).attr('data-chosen-id') === id) {
                    $(this).remove();
                }
            });
            count--;
        }
        if ($('.js-calendar-filter-chosen-list').find('.js-calendar-filter-chosen-item').length > 0) {
            $('.js-calendar-filter-chosen-reset').addClass('show');
        } else {
            $('.js-calendar-filter-chosen-reset').removeClass('show');
        }
        $('.b-museum-events__filter-inner-mobile-chosen span').text(count);
        if (count > 0) {
            $('.b-museum-events__filter-inner-mobile-reset').show();
        } else {
            $('.b-museum-events__filter-inner-mobile-reset').hide();
        }
    });
    $(document).on('click', '.js-calendar-filter-chosen-item', function() {
        id = $(this).attr('data-chosen-id');
        $('.js-calendar-filter-inner-item').each(function() {
            if ($(this).attr('data-id') === id) {
                $(this).removeClass('active');
                if ($(this).parents('.js-calendar-filter-item').find('.js-calendar-filter-inner-item.active').length === 0) {
                    $(this).parents('.js-calendar-filter-item').removeClass('chosen');
                }
            }
        });
        $(this).remove();
        if ($('.js-calendar-filter-chosen-list').find('.js-calendar-filter-chosen-item').length > 0) {
            $('.js-calendar-filter-chosen-reset').addClass('show');
        } else {
            $('.js-calendar-filter-chosen-reset').removeClass('show');
        }
    });
    $(document).on('click', '.js-calendar-filter-chosen-reset', function() {
        $('.js-calendar-filter-chosen-item').remove();
        $('.js-calendar-filter-inner-item').removeClass('active');
        $('.js-calendar-filter-item').removeClass('chosen');
        $(this).removeClass('show');
        count = 0;
        $('.b-museum-events__filter-inner-mobile-chosen span').text(count);
    });
    $('body').on('click', function(e) {
    	if (!((e.target).closest('.b-calendar-filter__inner-list')) && !((e.target).closest('.js-calendar-filter-item'))) {
    		$('.b-calendar-filter__inner-list').slideUp();
            $('.js-calendar-filter-item').removeClass('active');
    	}
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/calendar/calendar-filter.js